import React from "react";
export default function LineText(props) {
  const { className, ...rest } = props;
  return <p className={`p-0 m-0 ${className}`} {...rest}></p>;
}
